import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
/**
 * Scrolls to the top of the page
 * @param {boolean} alwaysOnRender  Scroll to top on every rerender
 */

var ScrollToTop =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollToTop, _Component);

  function ScrollToTop() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollToTop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollToTop)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.scrollToTop = function () {
      window.scrollTo(0, 0);
    };

    return _this;
  }

  _createClass(ScrollToTop, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.scrollToTop();
      } else if (this.props.alwaysOnRender) {
        this.scrollToTop();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.alwaysOnRender) {
        this.scrollToTop();
      }
    }
    /**
     * Scrolls to the top of the page
     */

  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(Component);

ScrollToTop.defaultProps = {
  alwaysOnRender: false
};
export default withRouter(ScrollToTop);